import { useState } from 'react';
import AreaChart from '../../../components/AreaChart';
import { config } from '../../../config/config';
import { ValueOf } from '../../../config/constants';
import usePoolState from '../../../context/pool/usePoolState';
// import useHistoricalLockedPoolLiquidity from '../../../hooks/analytics/useHistoricalLockedPoolLiquidity';
import useMockHistoricalLockedPoolLiquidity from '../../../hooks/analytics/useMockHistoricalLockedPoolLiquidity';
import Card from '../../../components/Card';

const PoolChart = () => {
    const { selectedLiquidityPool: selectedPool } = usePoolState();

    const [timeframeOption, setTimeframeOption] =
        useState<ValueOf<typeof config.areaChartTimeframes>>('1d');
    const [activePayload, setActivePayload] = useState<number | undefined>();

    // const { historicalLockedPoolLiquidity, defaultData, isLoading } =
    //     useHistoricalLockedPoolLiquidity(selectedPool?.poolId || '', timeframeOption);
    const { historicalLockedPoolLiquidity, defaultData, isLoading } =
        useMockHistoricalLockedPoolLiquidity(selectedPool?.poolId || '', timeframeOption);

    const handlePayloadChange = (newPayload: number | undefined) => {
        if (newPayload !== activePayload) {
            setActivePayload(newPayload);
        }
    };

    const handleTimeframeChange = (
        newTimeframe: ValueOf<typeof config.areaChartTimeframes>
    ) => {
        setTimeframeOption(newTimeframe);
    };

    return (
        <Card className='pool-chart'>
            <AreaChart
                isLoading={isLoading}
                data={historicalLockedPoolLiquidity ?? defaultData}
                domain={!historicalLockedPoolLiquidity ? [-100, 100] : undefined}
                withKpi
                activePayload={activePayload}
                onActivePayloadChange={handlePayloadChange}
                label='Total Value Locked'
                activePayloadLabel='Total Value Locked'
                withTimeFrames
                timeframes={config.areaChartTimeframes}
                onTimeframeChange={(timeframe) => handleTimeframeChange(timeframe)}
            />
        </Card>
    );
};

export default PoolChart;
